export const getInlineEditorViewStyles = () => ({
  choiceGroup: {
    root: {
      maxWidth: '190px',
      selectors: {
        'label.ms-ChoiceField-field': {
          padding: '0px',
        },
        'div.inherited-value': {
          paddingLeft: '30px',
          wordBreak: 'break-all',
        },
      },
    },
  },
  textField: {
    fieldGroup: {
      root: {
        selectors: {
          '&:after': {
            display: 'none',
          },
        },
      },
    },
  },
});
